var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vue-voucher-lines"},_vm._l((_vm.voucherLines),function(voucher){return _c('div',{staticClass:"discount"},[_vm._v(_vm._s(voucher.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }